var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading37_container"},[_c('div',{staticClass:"loop cubes"},[_c('div',{staticClass:"item cubes"}),_c('div',{staticClass:"item cubes"}),_c('div',{staticClass:"item cubes"}),_c('div',{staticClass:"item cubes"}),_c('div',{staticClass:"item cubes"}),_c('div',{staticClass:"item cubes"})])])
}]

export { render, staticRenderFns }